const Paths: any = {
	"/": "Заявки",
	"/managers": "Менеджеры",
	"/regions": "Места",
	"/candidates": "Кандидаты",
	"/vacancies": "Вакансии",
	"/tasks": "Задачи",
	"/interviews": "Собеседования",
	"/letters": "Рассылка",
	"/templates": "Шаблоны",
};

export default Paths;
